export const Roles = [
    "Service Admin",
    "Service Manager",    
    "Executive Service Admin",
    "Sales Rep Advanced Installer",
    "Service Sales Rep Advanced",    
    "Service Sales Rep Basic",
    "Service Sales Rep Viewer",    
    "Install Lead"
];